<template>
<div class="max-w-2xl w-full">
  <h4>{{ $t('message.salaryProject.addEmployee') }}</h4>
  <div>
    <div class="mt-4 flex" v-if="!request">
      <div class="w-1/4 text-right leading-form pr-4"></div>
      <div>
        <vs-radio class="pr-2" v-model="status" vs-value="0">{{ $tc('message.salaryProject.employeesStatus', 0) }}</vs-radio>
        <vs-radio v-model="status" vs-value="1">{{ $tc('message.salaryProject.employeesStatus', 1) }}</vs-radio>
      </div>
    </div>
    <vs-alert color="danger" v-if="!checkedCardNumber">
      <div>{{ $t('message.salaryProject.cartNull') }}</div>
    </vs-alert>
    <label class="flex mt-4">
      <div class="w-1/4 text-right leading-form pr-4">{{ $t('message.salaryProject.formCartNumber') }}</div>
      <vs-input class="inputx w-3/4" :danger="!checkedCardNumber" @input="stopRequest($event)"
                :value="cartNumber" @change="checkCard($event.target.value)"/>
    </label>
    <label class="flex mt-4">
      <div class="w-1/4 text-right leading-form pr-4">{{ $t('message.salaryProject.formCartTin') }}</div>
      <vs-input class="inputx w-3/4" :danger="!checkedTin" @input="stopRequestTin($event)"
                :value="tinNumber" @change="checkTin($event.target.value)"/>
    </label>
    <label class="mt-4 flex">
      <div class="w-1/4 text-right leading-form pr-4">{{ $t('message.salaryProject.formFIO') }}</div>
      <vs-input class="inputx w-3/4" v-model="lastName" :disabled="true"/>
    </label>
    <label class="flex mt-4" v-if="false">
      <div class="w-1/4 text-right leading-form pr-4">{{ $t('message.salaryProject.formName') }}</div>
      <vs-input class="inputx w-3/4" v-model="name"/>
    </label>
    <vs-divider />
    <label class="flex mt-4" v-if="false">
      <div class="w-1/4 text-right leading-form pr-4">{{ $t('message.salaryProject.formSecondName') }}</div>
      <vs-input class="inputx w-3/4" v-model="secondName"/>
    </label>
    <p class="w-full max-w-xs mx-auto pr-4" v-if="false">{{ $t('message.salaryProject.formBankDetails') }}</p>

    <vs-divider />
    <label class="flex mt-4">
      <div class="w-1/4 text-right leading-form pr-4">{{ $t('message.salaryProject.formPost') }}</div>
      <vs-input class="inputx w-3/4" v-model="post"/>
    </label>
    <div class="w-full sm:w-1/3 mx-auto text-center flex content-center pt-4" v-if="request && cartNumber === ''">
      <vs-button color="primary" type="gradient" class="request flex content-center" @click="$emit('create-request')">
        <div class="request flex content-center">
          <vs-icon icon="control_point" size="50px"></vs-icon>
          <span class="ml-4">{{ $t('message.salaryProject.formCartRequest') }}</span>
        </div>
      </vs-button>
    </div>
  </div>
  <div class="w-full sm:w-4/5 text-center mt-8 mx-auto">
    <vs-checkbox v-model="agree">{{ $t('message.salaryProject.formConfirm') }}</vs-checkbox>
  </div>
  <div class="w-full sm:w-2/3 mt-24 mx-auto">
    <vs-button @click="$emit('close-form')" line-origin="center"
               color="primary" type="flat" class="my-2 mr-2">
      {{ $t('message.salaryProject.formBack') }}
    </vs-button>
    <vs-button @click="confirmForm" line-origin="center" :disabled="!agree && checkedCardNumber"
               color="primary" type="gradient" class="my-2 mr-2 float-right">
      {{ $t('message.salaryProject.formCreate') }}
    </vs-button>
  </div>
</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'createForm',
  props: ['data'],
  data: () => ({
    lastName: '',
    name: '',
    secondName: '',
    post: '',
    cartNumber: '',
    tinNumber: '',
    accType: false,
    id: null,
    agree: true,
    request: true,
    status: '0',
    checkedCardNumber: true,
    checkedTin: true
  }),
  methods: {
    ...mapActions('utils', ['checkAccountNumber', 'checkAccountNumberTin']),
    clearForm () {
      this.lastName = this.data.tp_name || ''
      this.name = this.data.name || ''
      this.secondName = this.data.secondName || ''
      this.post = this.data.tp_position || ''
      this.cartNumber = this.data.card_numb || this.data.account_numb || ''
      this.id = this.data.id || null
      this.status = this.data.status || 0
      if (this.data.id !== null) this.request = false
      this.agree = !this.request
    },
    confirmForm () {
      if (this.cartNumber.length === 0) this.checkedCardNumber = false
      if (this.checkedCardNumber) {
        const data = {
          tp_name: `${this.lastName}`,
          tp_position: this.post,
          id: this.id,
          status: this.status,
          request: this.request,
          approve_process: 1
        }
        switch (this.accType) {
        case 1:
          data.account_numb = this.cartNumber
          break
        case 0:
          data.card_numb = this.cartNumber
        }
        this.$emit('confirm-form', data)
      }
    },
    closeForm () {
      this.$emit('close-form')
    },
    async checkCard (number) {
      this.cartNumber = number
      this.accType = 0
      let result = await this.checkAccountNumber({type: 0, number})
      if (result === false) {
        this.accType = 1
        result = await this.checkAccountNumber({type: 1, number})
      }
      if (result === false) {
        this.accType = false
        this.checkedCardNumber = false
      } else {
        this.checkedCardNumber = true
        this.lastName = result.data.tp_name
        this.tinNumber = result.data.tin
      }
    },
    async checkTin (number) {
      this.tinNumber = number
      const result = await this.checkAccountNumberTin(number)
      if (result === false) {
        this.accType = false
        this.checkedTin = this.checkedCardNumber = false
      } else {
        this.checkedTin = this.checkedCardNumber = true
        this.lastName = result.data.tp_name
        this.cartNumber = result.data.card_number || result.data.account_number
      }
    },
    stopRequest (number) {
      this.cartNumber = number
    },
    stopRequestTin (number) {
      this.tinNumber = number
    }
  },
  mounted () {
    this.clearForm()
  }
}
</script>

<style scoped>
  .request span {
    height: 50px;
    line-height: 55px;
  }
</style>
